<template>
    <div class="footer" v-if="!smallScreen">
      <div class="footer-container">
        <div class="footer-col-1">
          <figure id="footer-logo">
            <a href="/"><img src="../assets/images/logo.svg" /></a>
          </figure>
        </div>
        <div class="footer-col-2">
          <a href="/projekte">
            <p>Projekte</p>
          </a>
          <a href="/about">
            <p>Über mich</p>
          </a>
          <a href="/kontakt">
            <p>Kontakt</p>
          </a>
  
          <p></p>
  
          <a href="/impressum">
            <p>Impressum</p>
          </a>
          <a href="/datenschutz">
            <p>Datenschutz</p>
          </a>
        </div>
        <div class="footer-col-3">
          <p>Kontakt und Socials</p>
          <div class="footer-socials">
            <figure>
              <a href="mailto:hi.laradesigns@gmail.com">
                <span
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.73535 8.66667V8.7315V15.3333C5.73535 15.9547 6.23903 16.4583 6.86035 16.4583H17.3333C17.9547 16.4583 18.4583 15.9547 18.4583 15.3333V8.72118V8.66667V8.58941V7.94075L18.7358 7.75H18.4583V7.63737L18.2945 7.75H5.91098L5.73535 7.57981V7.75H5.55174L5.73535 7.92793V8.42565V8.66667ZM6.45581 9.27932L9.46837 12.004L6.40374 15.0314L6.45581 9.27932ZM10.0007 12.5223L10.0218 12.543L10.2873 12.804C10.4957 13.0091 10.7453 13.2554 10.9116 13.4217L10.9235 13.4337L10.9382 13.442L10.9394 13.4427C11.2973 13.6462 11.5531 13.7917 12 13.7917C12.2273 13.7917 12.3984 13.7403 12.5599 13.671C12.6237 13.6437 12.6872 13.6129 12.7503 13.5823C12.7649 13.5753 12.7795 13.5682 12.7941 13.5612C12.8728 13.5234 12.9541 13.4855 13.0455 13.4498L13.0457 13.4503L13.0559 13.4451C13.1525 13.3969 13.3081 13.2845 13.4978 13.1354C13.67 13.0001 13.878 12.8284 14.1095 12.632L16.9747 15.4859C16.8789 15.5219 16.7751 15.5417 16.6667 15.5417H6.96929L10.0007 12.5223ZM16.0003 10.9679C16.5642 10.4604 17.1111 9.96142 17.5417 9.56645V14.6667C17.5417 14.7606 17.5269 14.851 17.4995 14.9358L14.6746 12.1452C15.0943 11.779 15.5528 11.3706 16.0003 10.9679ZM6.65165 8.45833H17.3484L12.9262 12.5646L12.9146 12.571C12.8985 12.5797 12.8748 12.5922 12.8451 12.6073C12.7855 12.6375 12.7018 12.6778 12.606 12.7181C12.4097 12.8005 12.1793 12.875 12 12.875C11.8207 12.875 11.5903 12.8005 11.394 12.7181C11.2982 12.6778 11.2145 12.6375 11.1549 12.6073C11.1252 12.5922 11.1015 12.5797 11.0854 12.571L11.0738 12.5646L6.65165 8.45833ZM16.125 2.875H7.875C6.54892 2.875 5.27715 3.40178 4.33947 4.33947C3.40178 5.27715 2.875 6.54892 2.875 7.875V16.125C2.875 16.7816 3.00433 17.4318 3.2556 18.0384C3.50688 18.645 3.87517 19.1962 4.33947 19.6605C5.27715 20.5982 6.54892 21.125 7.875 21.125H16.125C16.7816 21.125 17.4318 20.9957 18.0384 20.7444C18.645 20.4931 19.1962 20.1248 19.6605 19.6605C20.1248 19.1962 20.4931 18.645 20.7444 18.0384C20.9957 17.4318 21.125 16.7816 21.125 16.125V7.875C21.125 7.21839 20.9957 6.56821 20.7444 5.96158C20.4931 5.35496 20.1248 4.80376 19.6605 4.33947C19.1962 3.87517 18.645 3.50688 18.0384 3.2556C17.4318 3.00433 16.7816 2.875 16.125 2.875ZM20.125 16.125C20.125 17.1859 19.7036 18.2033 18.9534 18.9534C18.2033 19.7036 17.1859 20.125 16.125 20.125H7.875C6.81413 20.125 5.79672 19.7036 5.04657 18.9534C4.29643 18.2033 3.875 17.1859 3.875 16.125V7.875C3.875 6.81413 4.29643 5.79672 5.04657 5.04657C5.79672 4.29643 6.81413 3.875 7.875 3.875H16.125C17.1859 3.875 18.2033 4.29643 18.9534 5.04657C19.7036 5.79672 20.125 6.81413 20.125 7.875V16.125Z"
                    />
                  </svg>
                </span>
              </a>
            </figure>
            <figure>
              <a
                href="https://www.linkedin.com/in/lara-wulf-396a2b213"
                target="_blank"
              >
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.8754 10L13.8751 10C13.431 9.99954 12.9919 10.0943 12.5874 10.278C12.2791 10.4181 11.9963 10.6073 11.75 10.8377V10.5C11.75 10.3674 11.6973 10.2402 11.6036 10.1464C11.5098 10.0527 11.3826 10 11.25 10C11.1174 10 10.9902 10.0527 10.8964 10.1464C10.8027 10.2402 10.75 10.3674 10.75 10.5V16.5C10.75 16.6326 10.8027 16.7598 10.8964 16.8536C10.9902 16.9473 11.1174 17 11.25 17C11.3826 17 11.5098 16.9473 11.6036 16.8536C11.6973 16.7598 11.75 16.6326 11.75 16.5V13.125C11.75 12.5614 11.9739 12.0209 12.3724 11.6224C12.7709 11.2239 13.3114 11 13.875 11C14.4386 11 14.9791 11.2239 15.3776 11.6224C15.7761 12.0209 16 12.5614 16 13.125V16.5C16 16.6326 16.0527 16.7598 16.1464 16.8536C16.2402 16.9473 16.3674 17 16.5 17C16.6326 17 16.7598 16.9473 16.8536 16.8536C16.9473 16.7598 17 16.6326 17 16.5L17 13.125L17 13.1246C16.9974 12.2967 16.6674 11.5034 16.082 10.918C15.4966 10.3326 14.7033 10.0026 13.8754 10ZM8.97754 7.98612C9.07368 7.84223 9.125 7.67306 9.125 7.5C9.125 7.26794 9.03281 7.04538 8.86872 6.88128C8.70462 6.71719 8.48206 6.625 8.25 6.625C8.07694 6.625 7.90777 6.67632 7.76388 6.77246C7.61998 6.86861 7.50783 7.00527 7.44161 7.16515C7.37538 7.32504 7.35805 7.50097 7.39181 7.6707C7.42557 7.84044 7.50891 7.99635 7.63128 8.11872C7.75365 8.24109 7.90956 8.32443 8.0793 8.35819C8.24903 8.39195 8.42496 8.37462 8.58485 8.30839C8.74473 8.24217 8.88139 8.13002 8.97754 7.98612ZM8.25 10C8.11739 10 7.99021 10.0527 7.89645 10.1464C7.80268 10.2402 7.75 10.3674 7.75 10.5V16.5C7.75 16.6326 7.80268 16.7598 7.89645 16.8536C7.99021 16.9473 8.11739 17 8.25 17C8.38261 17 8.50979 16.9473 8.60355 16.8536C8.69732 16.7598 8.75 16.6326 8.75 16.5V10.5C8.75 10.3674 8.69732 10.2402 8.60355 10.1464C8.50979 10.0527 8.38261 10 8.25 10ZM21.125 19.875V4.125C21.125 3.79348 20.9933 3.47554 20.7589 3.24112C20.5245 3.0067 20.2065 2.875 19.875 2.875H4.125C3.79348 2.875 3.47554 3.0067 3.24112 3.24112C3.0067 3.47554 2.875 3.79348 2.875 4.125V19.875C2.875 20.2065 3.0067 20.5245 3.24112 20.7589C3.47554 20.9933 3.79348 21.125 4.125 21.125H19.875C20.2065 21.125 20.5245 20.9933 20.7589 20.7589C20.9933 20.5245 21.125 20.2065 21.125 19.875ZM20.0518 3.94822C20.0987 3.99511 20.125 4.0587 20.125 4.125V19.875C20.125 19.9413 20.0987 20.0049 20.0518 20.0518C20.0049 20.0987 19.9413 20.125 19.875 20.125H4.125C4.0587 20.125 3.99511 20.0987 3.94822 20.0518C3.90134 20.0049 3.875 19.9413 3.875 19.875V4.125C3.875 4.0587 3.90134 3.99511 3.94822 3.94822C3.99511 3.90134 4.0587 3.875 4.125 3.875H19.875C19.9413 3.875 20.0049 3.90134 20.0518 3.94822Z"
                    />
                  </svg>
                </span>
              </a>
            </figure>
            <figure>
              <a href="https://www.instagram.com/laaaaaariiiii/" target="_blank">
                <span
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 7.75C11.1594 7.75 10.3377 7.99926 9.63883 8.46625C8.93992 8.93325 8.39518 9.59701 8.07351 10.3736C7.75184 11.1502 7.66768 12.0047 7.83166 12.8291C7.99565 13.6536 8.40042 14.4108 8.9948 15.0052C9.58917 15.5996 10.3464 16.0044 11.1709 16.1683C11.9953 16.3323 12.8498 16.2482 13.6264 15.9265C14.403 15.6048 15.0667 15.0601 15.5337 14.3612C16.0007 13.6623 16.25 12.8406 16.25 12C16.25 10.8728 15.8022 9.79183 15.0052 8.9948C14.2082 8.19777 13.1272 7.75 12 7.75ZM12 15.25C11.3572 15.25 10.7289 15.0594 10.1944 14.7023C9.65994 14.3452 9.24338 13.8376 8.99739 13.2437C8.75141 12.6499 8.68705 11.9964 8.81245 11.366C8.93785 10.7355 9.24738 10.1564 9.7019 9.7019C10.1564 9.24738 10.7355 8.93785 11.366 8.81245C11.9964 8.68705 12.6499 8.75141 13.2437 8.99739C13.8376 9.24338 14.3452 9.65994 14.7023 10.1944C15.0594 10.7289 15.25 11.3572 15.25 12C15.25 12.862 14.9076 13.6886 14.2981 14.2981C13.6886 14.9076 12.862 15.25 12 15.25ZM16.125 2.875H7.875C6.54892 2.875 5.27715 3.40178 4.33947 4.33947C3.40178 5.27715 2.875 6.54892 2.875 7.875V16.125C2.875 16.7816 3.00433 17.4318 3.2556 18.0384C3.50688 18.645 3.87517 19.1962 4.33947 19.6605C5.27715 20.5982 6.54892 21.125 7.875 21.125H16.125C16.7816 21.125 17.4318 20.9957 18.0384 20.7444C18.645 20.4931 19.1962 20.1248 19.6605 19.6605C20.1248 19.1962 20.4931 18.645 20.7444 18.0384C20.9957 17.4318 21.125 16.7816 21.125 16.125V7.875C21.125 7.21839 20.9957 6.56821 20.7444 5.96158C20.4931 5.35496 20.1248 4.80376 19.6605 4.33947C19.1962 3.87517 18.645 3.50688 18.0384 3.2556C17.4318 3.00433 16.7816 2.875 16.125 2.875ZM20.125 16.125C20.125 17.1859 19.7036 18.2033 18.9534 18.9534C18.2033 19.7036 17.1859 20.125 16.125 20.125H7.875C6.81413 20.125 5.79672 19.7036 5.04657 18.9534C4.29643 18.2033 3.875 17.1859 3.875 16.125V7.875C3.875 6.81413 4.29643 5.79672 5.04657 5.04657C5.79672 4.29643 6.81413 3.875 7.875 3.875H16.125C17.1859 3.875 18.2033 4.29643 18.9534 5.04657C19.7036 5.79672 20.125 6.81413 20.125 7.875V16.125ZM17.6025 7.61112C17.6987 7.46723 17.75 7.29806 17.75 7.125C17.75 6.89294 17.6578 6.67038 17.4937 6.50628C17.3296 6.34219 17.1071 6.25 16.875 6.25C16.7019 6.25 16.5328 6.30132 16.3889 6.39746C16.245 6.49361 16.1328 6.63027 16.0666 6.79015C16.0004 6.95004 15.9831 7.12597 16.0168 7.2957C16.0506 7.46544 16.1339 7.62135 16.2563 7.74372C16.3787 7.86609 16.5346 7.94943 16.7043 7.98319C16.874 8.01695 17.05 7.99962 17.2098 7.93339C17.3697 7.86717 17.5064 7.75502 17.6025 7.61112Z"
                    /></svg
                ></span>
              </a>
            </figure>
          </div>
        </div>
      </div>
      <p id="footer-copyright">© 2022 Lara Wulf</p>
    </div>
    <div class="footer" v-if="smallScreen">
      <div class="footer-container">
        <div class="footer-col-1">
          <figure id="footer-logo">
            <a href="/"><img src="../assets/images/logo.svg" /></a>
          </figure>
        </div>
        <div class="footer-col-2">
          <a href="/projekte">
            <p>Projekte</p>
          </a>
          <a href="/about">
            <p>Über mich</p>
          </a>
          <a href="/kontakt">
            <p>Kontakt</p>
          </a>
  
          <p></p>
  
          <a href="/impressum">
            <p>Impressum</p>
          </a>
          <a href="/datenschutz">
            <p>Datenschutz</p>
          </a>
          <div class="footer-socials">
            <figure>
              <a href="mailto:hi.laradesigns@gmail.com">
                <span
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.73535 8.66667V8.7315V15.3333C5.73535 15.9547 6.23903 16.4583 6.86035 16.4583H17.3333C17.9547 16.4583 18.4583 15.9547 18.4583 15.3333V8.72118V8.66667V8.58941V7.94075L18.7358 7.75H18.4583V7.63737L18.2945 7.75H5.91098L5.73535 7.57981V7.75H5.55174L5.73535 7.92793V8.42565V8.66667ZM6.45581 9.27932L9.46837 12.004L6.40374 15.0314L6.45581 9.27932ZM10.0007 12.5223L10.0218 12.543L10.2873 12.804C10.4957 13.0091 10.7453 13.2554 10.9116 13.4217L10.9235 13.4337L10.9382 13.442L10.9394 13.4427C11.2973 13.6462 11.5531 13.7917 12 13.7917C12.2273 13.7917 12.3984 13.7403 12.5599 13.671C12.6237 13.6437 12.6872 13.6129 12.7503 13.5823C12.7649 13.5753 12.7795 13.5682 12.7941 13.5612C12.8728 13.5234 12.9541 13.4855 13.0455 13.4498L13.0457 13.4503L13.0559 13.4451C13.1525 13.3969 13.3081 13.2845 13.4978 13.1354C13.67 13.0001 13.878 12.8284 14.1095 12.632L16.9747 15.4859C16.8789 15.5219 16.7751 15.5417 16.6667 15.5417H6.96929L10.0007 12.5223ZM16.0003 10.9679C16.5642 10.4604 17.1111 9.96142 17.5417 9.56645V14.6667C17.5417 14.7606 17.5269 14.851 17.4995 14.9358L14.6746 12.1452C15.0943 11.779 15.5528 11.3706 16.0003 10.9679ZM6.65165 8.45833H17.3484L12.9262 12.5646L12.9146 12.571C12.8985 12.5797 12.8748 12.5922 12.8451 12.6073C12.7855 12.6375 12.7018 12.6778 12.606 12.7181C12.4097 12.8005 12.1793 12.875 12 12.875C11.8207 12.875 11.5903 12.8005 11.394 12.7181C11.2982 12.6778 11.2145 12.6375 11.1549 12.6073C11.1252 12.5922 11.1015 12.5797 11.0854 12.571L11.0738 12.5646L6.65165 8.45833ZM16.125 2.875H7.875C6.54892 2.875 5.27715 3.40178 4.33947 4.33947C3.40178 5.27715 2.875 6.54892 2.875 7.875V16.125C2.875 16.7816 3.00433 17.4318 3.2556 18.0384C3.50688 18.645 3.87517 19.1962 4.33947 19.6605C5.27715 20.5982 6.54892 21.125 7.875 21.125H16.125C16.7816 21.125 17.4318 20.9957 18.0384 20.7444C18.645 20.4931 19.1962 20.1248 19.6605 19.6605C20.1248 19.1962 20.4931 18.645 20.7444 18.0384C20.9957 17.4318 21.125 16.7816 21.125 16.125V7.875C21.125 7.21839 20.9957 6.56821 20.7444 5.96158C20.4931 5.35496 20.1248 4.80376 19.6605 4.33947C19.1962 3.87517 18.645 3.50688 18.0384 3.2556C17.4318 3.00433 16.7816 2.875 16.125 2.875ZM20.125 16.125C20.125 17.1859 19.7036 18.2033 18.9534 18.9534C18.2033 19.7036 17.1859 20.125 16.125 20.125H7.875C6.81413 20.125 5.79672 19.7036 5.04657 18.9534C4.29643 18.2033 3.875 17.1859 3.875 16.125V7.875C3.875 6.81413 4.29643 5.79672 5.04657 5.04657C5.79672 4.29643 6.81413 3.875 7.875 3.875H16.125C17.1859 3.875 18.2033 4.29643 18.9534 5.04657C19.7036 5.79672 20.125 6.81413 20.125 7.875V16.125Z"
                    />
                  </svg>
                </span>
              </a>
            </figure>
            <figure>
              <a
                href="https://www.linkedin.com/in/lara-wulf-396a2b213"
                target="_blank"
              >
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.8754 10L13.8751 10C13.431 9.99954 12.9919 10.0943 12.5874 10.278C12.2791 10.4181 11.9963 10.6073 11.75 10.8377V10.5C11.75 10.3674 11.6973 10.2402 11.6036 10.1464C11.5098 10.0527 11.3826 10 11.25 10C11.1174 10 10.9902 10.0527 10.8964 10.1464C10.8027 10.2402 10.75 10.3674 10.75 10.5V16.5C10.75 16.6326 10.8027 16.7598 10.8964 16.8536C10.9902 16.9473 11.1174 17 11.25 17C11.3826 17 11.5098 16.9473 11.6036 16.8536C11.6973 16.7598 11.75 16.6326 11.75 16.5V13.125C11.75 12.5614 11.9739 12.0209 12.3724 11.6224C12.7709 11.2239 13.3114 11 13.875 11C14.4386 11 14.9791 11.2239 15.3776 11.6224C15.7761 12.0209 16 12.5614 16 13.125V16.5C16 16.6326 16.0527 16.7598 16.1464 16.8536C16.2402 16.9473 16.3674 17 16.5 17C16.6326 17 16.7598 16.9473 16.8536 16.8536C16.9473 16.7598 17 16.6326 17 16.5L17 13.125L17 13.1246C16.9974 12.2967 16.6674 11.5034 16.082 10.918C15.4966 10.3326 14.7033 10.0026 13.8754 10ZM8.97754 7.98612C9.07368 7.84223 9.125 7.67306 9.125 7.5C9.125 7.26794 9.03281 7.04538 8.86872 6.88128C8.70462 6.71719 8.48206 6.625 8.25 6.625C8.07694 6.625 7.90777 6.67632 7.76388 6.77246C7.61998 6.86861 7.50783 7.00527 7.44161 7.16515C7.37538 7.32504 7.35805 7.50097 7.39181 7.6707C7.42557 7.84044 7.50891 7.99635 7.63128 8.11872C7.75365 8.24109 7.90956 8.32443 8.0793 8.35819C8.24903 8.39195 8.42496 8.37462 8.58485 8.30839C8.74473 8.24217 8.88139 8.13002 8.97754 7.98612ZM8.25 10C8.11739 10 7.99021 10.0527 7.89645 10.1464C7.80268 10.2402 7.75 10.3674 7.75 10.5V16.5C7.75 16.6326 7.80268 16.7598 7.89645 16.8536C7.99021 16.9473 8.11739 17 8.25 17C8.38261 17 8.50979 16.9473 8.60355 16.8536C8.69732 16.7598 8.75 16.6326 8.75 16.5V10.5C8.75 10.3674 8.69732 10.2402 8.60355 10.1464C8.50979 10.0527 8.38261 10 8.25 10ZM21.125 19.875V4.125C21.125 3.79348 20.9933 3.47554 20.7589 3.24112C20.5245 3.0067 20.2065 2.875 19.875 2.875H4.125C3.79348 2.875 3.47554 3.0067 3.24112 3.24112C3.0067 3.47554 2.875 3.79348 2.875 4.125V19.875C2.875 20.2065 3.0067 20.5245 3.24112 20.7589C3.47554 20.9933 3.79348 21.125 4.125 21.125H19.875C20.2065 21.125 20.5245 20.9933 20.7589 20.7589C20.9933 20.5245 21.125 20.2065 21.125 19.875ZM20.0518 3.94822C20.0987 3.99511 20.125 4.0587 20.125 4.125V19.875C20.125 19.9413 20.0987 20.0049 20.0518 20.0518C20.0049 20.0987 19.9413 20.125 19.875 20.125H4.125C4.0587 20.125 3.99511 20.0987 3.94822 20.0518C3.90134 20.0049 3.875 19.9413 3.875 19.875V4.125C3.875 4.0587 3.90134 3.99511 3.94822 3.94822C3.99511 3.90134 4.0587 3.875 4.125 3.875H19.875C19.9413 3.875 20.0049 3.90134 20.0518 3.94822Z"
                    />
                  </svg>
                </span>
              </a>
            </figure>
            <figure>
              <a href="https://www.instagram.com/laaaaaariiiii/" target="_blank">
                <span
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 7.75C11.1594 7.75 10.3377 7.99926 9.63883 8.46625C8.93992 8.93325 8.39518 9.59701 8.07351 10.3736C7.75184 11.1502 7.66768 12.0047 7.83166 12.8291C7.99565 13.6536 8.40042 14.4108 8.9948 15.0052C9.58917 15.5996 10.3464 16.0044 11.1709 16.1683C11.9953 16.3323 12.8498 16.2482 13.6264 15.9265C14.403 15.6048 15.0667 15.0601 15.5337 14.3612C16.0007 13.6623 16.25 12.8406 16.25 12C16.25 10.8728 15.8022 9.79183 15.0052 8.9948C14.2082 8.19777 13.1272 7.75 12 7.75ZM12 15.25C11.3572 15.25 10.7289 15.0594 10.1944 14.7023C9.65994 14.3452 9.24338 13.8376 8.99739 13.2437C8.75141 12.6499 8.68705 11.9964 8.81245 11.366C8.93785 10.7355 9.24738 10.1564 9.7019 9.7019C10.1564 9.24738 10.7355 8.93785 11.366 8.81245C11.9964 8.68705 12.6499 8.75141 13.2437 8.99739C13.8376 9.24338 14.3452 9.65994 14.7023 10.1944C15.0594 10.7289 15.25 11.3572 15.25 12C15.25 12.862 14.9076 13.6886 14.2981 14.2981C13.6886 14.9076 12.862 15.25 12 15.25ZM16.125 2.875H7.875C6.54892 2.875 5.27715 3.40178 4.33947 4.33947C3.40178 5.27715 2.875 6.54892 2.875 7.875V16.125C2.875 16.7816 3.00433 17.4318 3.2556 18.0384C3.50688 18.645 3.87517 19.1962 4.33947 19.6605C5.27715 20.5982 6.54892 21.125 7.875 21.125H16.125C16.7816 21.125 17.4318 20.9957 18.0384 20.7444C18.645 20.4931 19.1962 20.1248 19.6605 19.6605C20.1248 19.1962 20.4931 18.645 20.7444 18.0384C20.9957 17.4318 21.125 16.7816 21.125 16.125V7.875C21.125 7.21839 20.9957 6.56821 20.7444 5.96158C20.4931 5.35496 20.1248 4.80376 19.6605 4.33947C19.1962 3.87517 18.645 3.50688 18.0384 3.2556C17.4318 3.00433 16.7816 2.875 16.125 2.875ZM20.125 16.125C20.125 17.1859 19.7036 18.2033 18.9534 18.9534C18.2033 19.7036 17.1859 20.125 16.125 20.125H7.875C6.81413 20.125 5.79672 19.7036 5.04657 18.9534C4.29643 18.2033 3.875 17.1859 3.875 16.125V7.875C3.875 6.81413 4.29643 5.79672 5.04657 5.04657C5.79672 4.29643 6.81413 3.875 7.875 3.875H16.125C17.1859 3.875 18.2033 4.29643 18.9534 5.04657C19.7036 5.79672 20.125 6.81413 20.125 7.875V16.125ZM17.6025 7.61112C17.6987 7.46723 17.75 7.29806 17.75 7.125C17.75 6.89294 17.6578 6.67038 17.4937 6.50628C17.3296 6.34219 17.1071 6.25 16.875 6.25C16.7019 6.25 16.5328 6.30132 16.3889 6.39746C16.245 6.49361 16.1328 6.63027 16.0666 6.79015C16.0004 6.95004 15.9831 7.12597 16.0168 7.2957C16.0506 7.46544 16.1339 7.62135 16.2563 7.74372C16.3787 7.86609 16.5346 7.94943 16.7043 7.98319C16.874 8.01695 17.05 7.99962 17.2098 7.93339C17.3697 7.86717 17.5064 7.75502 17.6025 7.61112Z"
                    /></svg
                ></span>
              </a>
            </figure>
          </div>
        </div>
      </div>
      <p id="footer-copyright">© 2022 Lara Wulf</p>
    </div>
  </template>
  
  <script>
  export default {
    inject: ["mq"],
    name: "FooterSection",
    computed: {
      smallScreen() {
        return this.mq.current == "sm";
      },
    },
  };
  </script>
  
  <style>
  .footer {
    min-height: 100%;
  }
  
  .footer-container {
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    padding-top: 100px;
    padding-bottom: 30px;
    align-items: stretch;
  }
  
  .footer-container > div {
    align-items: flex-start;
  }
  
  .footer-col-1 {
    display: flex;
    flex-direction: column;
    flex-flow: column nowrap;
  }
  
  .footer-col-2,
  .footer-col-3 {
    display: flex;
    flex-direction: column;
  
    gap: 30px;
  }
  
  .footer-container p,
  .footer p {
    margin: 0;
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    /* identical to box height */
  
    letter-spacing: 0.2em;
    text-transform: uppercase;
  
    color: #f5f5f5;
  }
  
  .footer a {
    text-decoration: none;
  }
  
  .footer a:hover p {
    color: #bfb5aa;
  }
  
  #footer-logo {
    margin: 0px;
  }
  
  #footer-logo img {
    width: 100%;
  }
  
  #footer-copyright {
    color: #bfb5aa;
    letter-spacing: 0em;
    line-height: auto;
    padding-bottom: 30px;
    margin-left: 0px;
  }
  
  .footer-socials {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10%;
    width: 100%;
    height: 40px;
  }
  
  .footer-socials figure {
    height: 100%;
    width: 40px;
    margin: 0;
  }
  
  .footer-socials a,
  .footer-socials span,
  .footer-socials svg {
    height: 100%;
    width: 100%;
  }
  
  .footer-socials a svg {
    fill: #f5f5f5;
    stroke: #171512;
    stroke-width: 0.25;
  }
  
  .footer-socials a:hover svg {
    fill: #a39585;
  }
  
  @media only screen and (max-width: 960px) {
    .footer-container {
      gap: 10vw;
      justify-content: space-between;
      padding-bottom: 70px;
      padding-top: 50px;
    }
  
    .footer-col-1 {
      width: 20%;
    }
  }
  
  @media only screen and (min-width: 961px) {
    .footer-container > div {
      width: 33%;
    }
  }
  </style>
  